import { useEffect, useRef, useState } from 'react';

function gl_start(canvas, scene) {
   setTimeout(function() {
      gl = canvas.getContext('webgl2');
      canvas.setShaders = function(vertexShader, fragmentShader) {
	 gl.program = gl.createProgram();
         function addshader(type, src) {
            let shader = gl.createShader(type);
            gl.shaderSource(shader, src);
            gl.compileShader(shader);
            if (! gl.getShaderParameter(shader, gl.COMPILE_STATUS))
               console.log('Cannot compile shader:', gl.getShaderInfoLog(shader));
            gl.attachShader(gl.program, shader);
         };
         addshader(gl.VERTEX_SHADER, vertexShader);
         addshader(gl.FRAGMENT_SHADER, fragmentShader);
         gl.linkProgram(gl.program);
         if (! gl.getProgramParameter(gl.program, gl.LINK_STATUS))
            console.log('Could not link the shader program!');
         gl.useProgram(gl.program);
         gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
         gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([ -1, 1,0,   1, 1,0,  -1,-1,0,
	                                                    1,-1,0,  -1,-1,0,   1, 1,0 ]), gl.STATIC_DRAW);
         let aPos = gl.getAttribLocation(gl.program, 'aPos');
         gl.enableVertexAttribArray(aPos);
         gl.vertexAttribPointer(aPos, 3, gl.FLOAT, false, 0, 0);
      }
      // initial compile
      canvas.setShaders(scene.vertexShader, scene.fragmentShader);
      setInterval(function() {
         // If scene requested a shader swap (mode changed), perform it here
         // inside the draw loop before updating uniforms so the update binds
         // to the new program. This avoids a frame where uniforms are set on
         // a stale program and reduces flicker when toggling modes/materials.
         if (scene._pendingShader) {
            try {
               canvas.setShaders(scene.vertexShader, scene.fragmentShader);
            } catch (e) {
               console.error('shader swap failed', e);
            }
            scene._pendingShader = false;
         }

         if (scene.update)
            scene.update([0,0,7]);

         gl.drawArrays(gl.TRIANGLES, 0, 6);
      }, 30);
   }, 100);
}
let gl, _ = {};
let setUniform = (type,name,a,b,c) => (gl['uniform'+type])(gl.getUniformLocation(gl.program,name), a,b,c);

export default function Specular(){
  const canvasRef = useRef();
   const sceneRef = useRef();
   const [isAmbient, setIsAmbient] = useState(true);
   const [isMetallic, setIsMetallic] = useState(false);

  function Scene() {

let NS = 1;
let NL = 2;

    // base vertex shader used for both modes
    this.vertexShader = `\
#version 300 es
in  vec3 aPos;
out vec3 vPos;
void main() {
   gl_Position = vec4(aPos, 1.);
   vPos = aPos;
}`;

   // --- SPECULAR fragment shader (original) ---
   const specularFS = `\
#version 300 es
precision highp float;
uniform float uTime;
uniform vec3 uViewPoint;

uniform vec3 uC[${NS}],
          uAmbient[${NS}],
    uDiffuse[${NS}],
          uL[${NL}],
    uLC[${NL}];

uniform vec4 uS[${NS}],
          uSpecular[${NS}];

in  vec3 vPos;
out vec4 fragColor;

vec2 raySphere(vec3 V, vec3 W, vec4 S) {
   V -= S.xyz;
   float b = dot(V, W);
   float d = b * b - dot(V, V) + S.w * S.w;
   if (d < 0.)
      return vec2(1001.,1000.);
   return vec2(-b - sqrt(d), -b + sqrt(d));
}

vec3 phong(vec3 N, vec3 L, vec3 W,
           vec3 diffuse, vec4 specular) {
   // diffuse term
   float NdotL = max(dot(N,L),0.0);
   vec3 diff = diffuse * NdotL;

   // specular term
   vec3 R = 2.0 * N * dot(N, L) - L;
   float highlight = max(0.0, -dot(R, W));
   vec3 spec = specular.rgb * pow(highlight, specular.a);

   return diff + spec;
}


vec3 shadeSphere(vec4 S, vec3 P, vec3 W, vec3 ambient, vec3 diffuse, vec4 specular) {
   vec3 N = (P - S.xyz) / S.w;
   vec3 shade = ambient;
   for (int l = 0 ; l < ${NL} ; l++)
      shade += uLC[l] * phong(N, uL[l], W,
                  diffuse,
                  specular);
   return shade;
}

void main() {
   vec4 F = vec4(0.);
   vec3 V = uViewPoint;
   vec3 W = normalize(vPos-V);
   float t = 100.;

   for (int i = 0 ; i < ${NS} ; i++) {
      vec2 tt = raySphere(V, W, uS[i]);
      if (tt.x < tt.y && tt.x > 0. && tt.x < t) {
         t = tt.x;
    vec3 P = V + t * W;
         F = vec4(shadeSphere(uS[i], P, W,
                          uAmbient[i],
                  uDiffuse[i],
                  uSpecular[i]), 1.);
      }
   }

   fragColor = vec4(sqrt(F.rgb), F.a);
}`;

   // --- AMBIENT fragment shader (simpler) ---
   const ambientFS = `\
#version 300 es
precision highp float;
uniform float uTime;
uniform vec3 uViewPoint;

uniform vec4 uS[${NS}];
uniform vec3 uC[${NS}],uL[${NL}],uLC[${NL}];

in  vec3 vPos;
out vec4 fragColor;

vec2 raySphere(vec3 V, vec3 W, vec4 S) {
   V -= S.xyz;
   float b = dot(V, W);
   float d = b * b - dot(V, V) + S.w * S.w;
   if (d < 0.)
      return vec2(1001.,1000.);
   return vec2(-b - sqrt(d), -b + sqrt(d));
}

vec3 shadeSphere(vec4 S, vec3 P, vec3 C) {
   vec3 N = (P - S.xyz) / S.w;
   vec3 shade = vec3(.1);
   for (int l = 0 ; l < ${NL} ; l++)
      shade += uLC[l] * max(0., dot(N, uL[l]));
   return C * shade;
}

void main() {
   vec4 F = vec4(0.);
   vec3 V = uViewPoint;
   vec3 W = normalize(vPos-V);
   float t = 100.;

   for (int i = 0 ; i < ${NS} ; i++) {
      vec2 tt = raySphere(V, W, uS[i]);
      if (tt.x < tt.y && tt.x > 0. && tt.x < t) {
         t = tt.x;
    vec3 P = V + t * W;
         F = vec4(shadeSphere(uS[i],P,uC[i]),1.);
      }
   }

   fragColor = vec4(sqrt(F.rgb), F.a);
}`;

    // default mode: specular
    this.fragmentShader = specularFS;
    this._specularFS = specularFS;
    this._ambientFS = ambientFS;

      // allow external toggling of mode; mark pending shader swap so gl_start
      // will perform the actual compile inside the draw loop.
      this.setMode = (ambientFlag) => {
         this.fragmentShader = ambientFlag ? this._ambientFS : this._specularFS;
         this._pendingShader = true;
      };

      // allow material selection (plastic vs metallic)
      this._isMetallic = false;
      this.setMaterial = (metalFlag) => { this._isMetallic = metalFlag; };

let startTime = Date.now()/1000;

let normalize = v => {
   let s = Math.sqrt(v[0]*v[0]+v[1]*v[1]+v[2]*v[2]);
   return [ v[0]/s, v[1]/s, v[2]/s ];
}

this.update = viewPoint => {
   let time = Date.now()/1000 - startTime;
   setUniform('1f', 'uTime', time);
   setUniform('3fv', 'uViewPoint', viewPoint);
   // Common uniforms
   setUniform('4fv', 'uS', [ 0,0,0,.4 ]);

   // If the current fragment shader is the ambient one, set only the
   // uniforms it expects. Otherwise set the specular-related uniforms.
   if (this.fragmentShader === this._ambientFS) {
      // use yellow color in ambient-only mode
      setUniform('3fv', 'uC', [ 1,0.5,0 ]);
      setUniform('3fv', 'uL', [ normalize([-1,1,1]), normalize([1,-1,-.5]) ].flat());
      setUniform('3fv', 'uLC', [ .5,.7,1, .2,.15,.1 ]);
   } else {
      // yellow specular mode
      setUniform('3fv', 'uAmbient', [ .1,.05,.0 ]);
      setUniform('3fv', 'uDiffuse', [ 1,0.5,0 ]);
      // specular depends on selected material: metallic matches base color
      if (this._isMetallic) {
         // metallic: specular color equals base diffuse (yellow) and visible
         setUniform('4fv', 'uSpecular', [ 1,0.5,0,20 ]);
      } else {
         // plastic: neutral white specular
         setUniform('4fv', 'uSpecular', [ 1,1,1,20 ]);
      }

      setUniform('3fv', 'uL', [
         normalize([(-.35), (.35), .35]),
         normalize([1,-1,-.5]),
      ].flat());

      setUniform('3fv', 'uLC', [ .5,.7,1, .2,.15,.1 ]);
   }
}

}

   useEffect(() => {
      const canvas = canvasRef.current;
      const scene = new Scene();
      sceneRef.current = scene;
      gl_start(canvas, scene);
      return () => {
         // noop for now; gl_start uses an interval and clears on unmount implicitly isn't wired.
      };
   }, []);

   // When user toggles ambient/specular, switch shaders at runtime.
   useEffect(() => {
      const scene = sceneRef.current;
      if (!scene || typeof scene.setMode !== 'function') return;
      scene.setMode(isAmbient);
   }, [isAmbient]);

      // inform the scene about material changes
      useEffect(() => {
         const scene = sceneRef.current;
         if (scene && typeof scene.setMaterial === 'function') {
            scene.setMaterial(isMetallic);
         }
      }, [isMetallic]);

   return (
      <div style={{ background: 'black', textAlign: '', position: 'relative', }}>
         
            <div style={{ position: 'absolute', left: 40, top: 40, zIndex: 1, display: 'flex', gap: '12px', alignItems: 'center' }}>
               
               <div style={{ display: 'flex', flexDirection : "column", alignItems: 'center', gap: '8px', color: 'white', fontSize: '14px' }} >
               <span style={{ userSelect: 'none', color : "white" }}>phong on</span>
                  <label className="switch2" style={{ margin: 0 }}>
                     <input type="checkbox" checked={!isAmbient} onChange={() => setIsAmbient(v => !v)} />
                     <span className="slider2">
                        <span className="material-symbols-outlined icon">light</span>
                     </span>
                  </label>
               <span style={{ userSelect: 'none', color : "white" }}>phong off</span>
               </div>
               

               <br/>

               <div style={{ display: 'flex', flexDirection : "column", alignItems: 'center', gap: '8px', color: 'white', fontSize: '14px', opacity: (!isAmbient ? 1 : 0.25), pointerEvents : (!isAmbient ? "auto" : "none" ), cursor: (!isAmbient ? 'pointer' : 'default') }}>
                  <span style={{ userSelect: 'none', color : "white" }}>metalic</span>
                  <label className="switch2" style={{ margin: 0 }}>
                     <input type="checkbox" checked={isMetallic} onChange={() => setIsMetallic(v => !v)} disabled={isAmbient} />
                     <span className="slider2">
                        <span className="material-symbols-outlined icon">flare</span>
                     </span>
                  </label>
                  <span style={{ userSelect: 'none', color : "white" }}>plastic</span>
               </div>
            </div>
         
         <center><canvas ref = { canvasRef } width = {720} height = {720} /></center>
      </div>
   );
}
